import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { IdentityService } from '../../services/identity.service';
import { catchError, switchMap, withLatestFrom } from 'rxjs/operators';
import { share } from 'rxjs';
import { IdentityActions } from '@states/identity/identity.action-types';

@Injectable()
export class IdentityEffect {

  public getSignUpInviteById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IdentityActions.getUserIdentities),
      withLatestFrom(this.store$.pipe(select(state => state.userState))),
      switchMap(([, { email }]) =>
        this.identityService.getUserIdentities(email)
          .pipe(
            switchMap((res) => {
              return [
                IdentityActions.getUserIdentitiesSuccess({ identities: res }),
              ];
            }),
            catchError(err => {
              return [
                IdentityActions.getUserIdentitiesFail(),
              ];
            }),
          ),
      ),
      share(),
    ),
  );


  constructor(
    private actions$: Actions,
    private store$: Store<AppState>,
    private identityService: IdentityService) {
  }
}
